import setPromiseState from '../../utils/promiseState';

export default{
  dataForEdit: {},
  error: {},
  successUpdated: false,
  isOpenModalChangeEmail: false,
  isOpenModalChangePassword: false,
  isOpenModalDeleteAccount: false,
  promise: {
    editProfile: setPromiseState(),
    editEmail: setPromiseState(),
    editPassword: setPromiseState(),
    deleteAccount: setPromiseState()
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Profile/InitState.js